import React, { useState, useEffect } from "react";
import registration from "../../assets/images/registration-img.png";
import { toast } from "react-toastify";
import useOtpTimer from "../../hooks/useOtpTimer";
import OtpInput from '../OtpInput';

const NewPasswordModal = ({ email }) => {
  const [values, setValues] = useState({
    email: "",
    password: "",
    confirm_password: "",
  });
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const { timeLeft, isActive, resetTimer, formatTime } = useOtpTimer(5);

  // Add this useEffect to reset timer when modal opens
  useEffect(() => {
    resetTimer(); // Reset timer when component mounts
  }, []); // Empty dependency array means this runs once when component mounts

  const resetForm = () => {
    setValues({
      email: "",
      password: "",
      confirm_password: "",
    });
    setOtp("");
    setShowPassword(false);
    setShowPassword1(false);
    setLoading(false);
    resetTimer();
  };

  useEffect(() => {
    const newPasswordModal = document.getElementById("new-password");

    newPasswordModal.addEventListener("hidden.bs.modal", resetForm);
    newPasswordModal.addEventListener("show.bs.modal", resetForm);

    return () => {
      newPasswordModal.removeEventListener("hidden.bs.modal", resetForm);
      newPasswordModal.removeEventListener("show.bs.modal", resetForm);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const validateNewPassword = () => {
    const { password, confirm_password } = values;
    const toastId = "validate-new";

    if (!otp?.trim()) {
      toast.error("Please Enter OTP", { toastId });
      return false;
    }

    if (!password) {
      toast.error("Password Field Required", { toastId });
      return false;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters long", { toastId });
      return false;
    }

    if (!confirm_password) {
      toast.error("Confirm Password Field Required", { toastId });
      return false;
    }

    if (password !== confirm_password) {
      toast.error("Confirm Password Not Matched", { toastId });
      return false;
    }

    return true;
  };
  // console.log("Form data:", values);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateNewPassword()) {
      setLoading(true);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/emails/verify-otp`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: email,
              otp: otp,
              password: values.password,
            }),
          }
        );
        const data = await res.json();

        if (data.success) {
          const res = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/users/update-password`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ email: email, password: values.password }),
            }
          );
          const data = await res.json();
          if (data.success) {
            toast.success(data.message);
            resetForm();
            const newPasswordModalEl = document.getElementById("new-password");
            const newPasswordInstance =
              window.bootstrap.Modal.getInstance(newPasswordModalEl);
            newPasswordInstance.hide();
            const loginModalEl = document.querySelector("#login");
            const loginModal = new window.bootstrap.Modal(loginModalEl);
            loginModal.show();
          } else {
            toast.error(data.message);
          }
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        resetForm();
        // console.log("verify otp error", error);
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/emails/send-email-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: email }),
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        resetTimer();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      // console.log("otp resend error", error);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <div
        className="modal fade registration"
        id="new-password"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="fa fa-times" />
            </button>
            <div className="modal-body">
              <div className="row gx-0">
                <div className="col-lg-6 h-100 d-xl-block d-lg-block d-none">
                  <div className="registration-img">
                    <img
                      src={registration}
                      className="w-100 h-100"
                      alt="registration"
                    />
                    <div className="registration-content">
                      <h3 className="text-white">Forgot Password</h3>
                      <p className="text-white">
                        Please provide your registered Mobile number. Get
                        started into
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="registration-frm">
                    <h4 className="title d-lg-none d-block">Forgot Password</h4>
                    <form action="" onSubmit={handleSubmit}>
                      <div className="registration-bx text-center">
                        <label htmlFor="" className="mb-3">Enter OTP</label>
                        <OtpInput
                          length={4}
                          onOtpSubmit={(value) => setOtp(value)}
                        />
                      </div>
                      <div className="registration-bx">
                        <label htmlFor="">New Password</label>
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter New Password"
                        />
                        <span
                          className="eye-btn"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={` ${
                              showPassword ? "fas fa-eye" : "fas fa-eye-slash"
                            }`}
                          ></i>
                        </span>
                      </div>
                      <div className="registration-bx">
                        <label htmlFor="">Confirm New Password</label>
                        <input
                          type={showPassword1 ? "text" : "password"}
                          name="confirm_password"
                          value={values.confirm_password}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter Confirm New Password"
                        />
                        <span
                          className="eye-btn"
                          onClick={() => setShowPassword1(!showPassword1)}
                        >
                          <i
                            className={` ${
                              showPassword1 ? "fas fa-eye" : "fas fa-eye-slash"
                            }`}
                          ></i>
                        </span>
                      </div>
                      <div className="registration-bx">
                        <button
                          className="thm-btn dark w-100 rounded-5 p-3 bg-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Save"
                          )}
                          {/* Save */}
                        </button>
                      </div>
                      <div className="text-center mt-3 mb-3">
                        <p className="text-center fz-18 mb-2">
                          OTP valid for: {formatTime()}
                        </p>
                        <button
                          type="button"
                          onClick={handleResendOtp}
                          className={`txt-org fw-600 border-0 bg-transparent ${
                            isActive ? "disabled" : ""
                          }`}
                          disabled={isActive}
                        >
                          Resend OTP
                        </button>
                      </div>
                      <p className="clr fz-18 text-center mt-4">
                        Existing Members?{" "}
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#login"
                          className="txt-org fw-600"
                        >
                          Sign In
                        </a>
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPasswordModal;
